
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';
import { useHeaderAuth } from '@/hooks/useHeaderAuth';
import Logo from './nav/Logo';
import DesktopNav from './nav/DesktopNav';
import MobileMenu from './nav/MobileMenu';
import HeaderButtons from './nav/HeaderButtons';
import { mainNavLinks, extraNavLinks } from './nav/navigationData';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isMobile = useIsMobile();
  const { user, loading, handleLogout } = useHeaderAuth();
  const location = useLocation();
  
  // Don't show header on the landing page
  if (location.pathname === '/') {
    return null;
  }
  
  // Close mobile menu when screen size changes to desktop
  useEffect(() => {
    if (!isMobile && isMenuOpen) {
      setIsMenuOpen(false);
    }
  }, [isMobile]);
  
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  
  if (loading) {
    return (
      <header className="fixed top-0 left-0 right-0 border-b border-white/10 bg-black/60 backdrop-blur-md z-50 animate-slide-down">
        <div className="flex items-center justify-between p-4">
          <Logo />
          <div className="w-9 h-9 rounded-full bg-black/50 animate-pulse"></div>
        </div>
      </header>
    );
  }
  
  return (
    <header className="fixed top-0 left-0 right-0 border-b border-white/10 bg-black/60 backdrop-blur-md z-50 animate-slide-down">
      <div className="flex items-center justify-between p-4">
        <div className="flex items-center gap-6">
          <Logo />
          
          {!isMobile && <DesktopNav mainNavLinks={mainNavLinks} extraNavLinks={extraNavLinks} />}
        </div>
        
        <HeaderButtons 
          user={user}
          onLogout={handleLogout}
          isMenuOpen={isMenuOpen}
          toggleMenu={toggleMenu}
        />
      </div>
      
      <MobileMenu
        isOpen={isMobile && isMenuOpen}
        navLinks={[...mainNavLinks, ...extraNavLinks]}
        onClose={() => setIsMenuOpen(false)}
        onLogout={handleLogout}
      />
    </header>
  );
};

export default Header;
